"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sestola": {
    "6b987da5": [{
      "hkey": "7ad476ea",
      "slug": "sestola",
      "name": "Sestola",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-val-di-sasso": [{
      "hkey": "7ad476ea",
      "slug": "sestola",
      "name": "Sestola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7f3ee52": [{
      "hkey": "cbf92c83",
      "slug": "rocchetta-sandri",
      "name": "Rocchetta Sandri",
      "primary": true,
      "skipSearch": false
    }],
    "rocchetta": [{
      "hkey": "cbf92c83",
      "slug": "rocchetta-sandri",
      "name": "Rocchetta Sandri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;